import type { HealthParameterKey } from '@/domain/health';
import { normalizeHealthParameterKey } from '@/domain/health';

export interface HealthMetricUiConfig {
    labelKey: string;
    healthPath: string;
}

/**
 * Maps overview `HealthParameterKey` values to Health routes and i18n labels.
 * Labels use `healthModule.routes.*` to match cage-health sidebar navigation.
 */
const HEALTH_METRIC_UI_CONFIG: Record<HealthParameterKey, HealthMetricUiConfig> = {
    bodyWounds: {
        labelKey: 'healthModule.routes.bodyWounds',
        healthPath: 'body-wounds/laksvel',
    },
    snoutWounds: {
        labelKey: 'healthModule.routes.snoutWounds',
        healthPath: 'snout-wounds',
    },
    maturity: {
        labelKey: 'healthModule.routes.maturation',
        healthPath: 'maturation',
    },
    scaleLoss: {
        labelKey: 'healthModule.routes.scaleLoss',
        healthPath: 'scale-loss',
    },
    skinBleeding: {
        labelKey: 'healthModule.routes.skinBleeding',
        healthPath: 'skin-bleeding',
    },
    finDamage: {
        labelKey: 'healthModule.routes.finStatus',
        healthPath: 'fin-status',
    },
    emaciation: {
        labelKey: 'healthModule.routes.emaciation',
        healthPath: 'emaciation',
    },
    deformity: {
        labelKey: 'healthModule.routes.spine',
        healthPath: 'deformities/spine',
    },
    deformedJaw: {
        labelKey: 'healthModule.routes.jaw',
        healthPath: 'deformities/jaw',
    },
    gillLid: {
        labelKey: 'healthModule.routes.gillLid',
        healthPath: 'deformities/gill-lid',
    },
    cataract: {
        labelKey: 'healthModule.routes.cataract',
        healthPath: 'cataract',
    },
    eyeDamage: {
        labelKey: 'healthModule.routes.eyeDamage',
        healthPath: 'eye-damage',
    },
};

const DEFAULT_METRIC_UI_CONFIG: HealthMetricUiConfig = {
    labelKey: '',
    healthPath: '',
};

export function getHealthMetricUiConfig(metricKey: string): HealthMetricUiConfig {
    const normalizedKey = normalizeHealthParameterKey(metricKey);

    if (normalizedKey) {
        return HEALTH_METRIC_UI_CONFIG[normalizedKey];
    }

    return {
        ...DEFAULT_METRIC_UI_CONFIG,
        labelKey: metricKey,
    };
}
